//  disable submit button when policy checkbox does NOT filled
//  submit button class : .js-submit-btn
function requireCheck(target, id) {
  if(target.checked) {
    document.querySelector(`.js-submit-btn${id}`).classList.remove('js-submit-disabled');
  }
  if(!target.checked) {
    document.querySelector(`.js-submit-btn${id}`).classList.add('js-submit-disabled');
  }
}

window.addEventListener('DOMContentLoaded', ()=>{
  const swiperElements = document.querySelectorAll('.swiper');
  swiperElements.forEach((swiperElement) => {
    const anchorElements = swiperElement.querySelectorAll('a');
    anchorElements.forEach((anchorElement) => {
      anchorElement.addEventListener('mousedown', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
      });
    });
  });
});

function cartAddTest(product_id) {
   let formdata = {
     items: [
        {
          id: product_id,
          quantity: 1,
        },
      ]
   };
   
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formdata)
  })
  .then(response => {
    console.log('cart added');
    console.log(response.json);
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}


const target = document.body;
let scrollbarWidth = window.innerWidth - document.body.clientWidth;

const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if(mutation.target.classList.contains('no-scroll')) {
          mutation.target.style.paddingRight = scrollbarWidth + 'px';
        } else {
          mutation.target.style.paddingRight = '0px';
        }
    });
});

const config = {
    attributes: true,
};

observer.observe(target, config);
